import * as types from "./mutation_types";

export default {
  [types.LINK_DELETE_TOGGLE_LOADING](state) {
    Object.assign(state, { error: "", isLoading: !state.isLoading });
  },
};
